import { Box, Typography, styled, Button } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "60px",
  width: "100%",
});

export const ModalTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 700,
  color: colors.text.primary,
  textAlign: "center",
  fontFamily: "Sora, sans-serif",
  marginBottom: "16px",
});

export const ModalText = styled(Typography)({
  fontSize: "18px",
  fontWeight: 500,
  color: colors.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito, sans-serif",
  marginBottom: "44px",
});

export const ButtonsContainer = styled(Box)({
  display: "flex",
  gap: "24px",
  justifyContent: "center",
});

export const CancelButton = styled(Button)({
  height: "48px",
  minWidth: "140px",
  borderRadius: "8px",
  border: `1px solid ${colors.border.medium}`,
  color: colors.primary.main,
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "none",
  fontFamily: "Nunito, sans-serif",
  backgroundColor: "transparent",

  "&:hover": {
    backgroundColor: colors.background.lightBlue,
    borderColor: colors.border.medium,
  },
});

export const DeleteButton = styled(Button)({
  height: "48px",
  minWidth: "140px",
  borderRadius: "8px",
  backgroundColor: colors.status.error,
  color: "#FFFFFF",
  fontWeight: 600,
  fontSize: "16px",
  textTransform: "none",
  fontFamily: "Nunito, sans-serif",
  boxShadow: "none",

  "&:hover": {
    backgroundColor: "#D32F2F",
    boxShadow: "none",
  },

  "&:disabled": {
    backgroundColor: colors.border.light,
    color: colors.text.secondary,
  },
});

